<template>
  <van-overlay :show="show" z-index="2006">
    <div class="wrapper" @click.stop>
      <div class="carmartbox">
        <div class="topbtn">
          <van-icon name="cross" @click="stopNavigator" />
          <van-icon name="replay" @click="reset" />
        </div>
        <div class="video" v-show="!haspic">
          <img class="rlcj" :src="isiOS ? iospic : androdpic" />
          <video
            id="videoCamera"
            class="img_bg_camera bg1"
            :width="videoWidth"
            :height="videoHeight"
            playsinline
            autoplay
          />
          <canvas
            id="canvasCamera"
            style="display: none"
            :width="videoWidth2"
            :height="videoHeight2"
          />
        </div>
        <img
          v-show="haspic"
          :width="facingMode == 'environment'?(videoWidth*wps):videoWidth"
          :height="facingMode == 'environment'?(videoHeight*hps):videoHeight"
          :src="imgSrc"
          alt
          class="tx_img"
        />
        <div class="btn">
          <van-button type="info" v-if="haspic" @click="save">保存</van-button>
          <van-button type="info" plain v-else @click="setImage"
            >拍照</van-button
          >
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      videoWidth: 360,
      videoHeight: 480,
      videoWidth2: 360,
      videoHeight2: 480,
      wps:0.95,
      hps:0.45,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      show: false,
      openCamera: false,
      haspic: false,
      cameraTarget: null,
      camreass: [],
      filename: '', //文件重命名
      option: {
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 468, // 默认生成截图框宽度
        autoCropHeight: 331, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1.414, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      default_cap_id: '', //默认摄像头id
      mediaStream: null, // 用于接收打开的媒体
      isiOS: false
    }
  },
  props: {
    // 遮罩图片 ios
    iospic: {
      type: String,
      default: require('@assets/img/rlcj.png')
    },
    // 遮罩图片 安卓
    androdpic: {
      type: String,
      default: require('@assets/img/rlcj2.png')
    },
    // 摄像头 'user':前置  'environment':后置
    facingMode: {
      type: String,
      default:'user'
    }
  },
  mounted() {
    var u = navigator.userAgent
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    var iisOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

    // iisOS=1
    if (iisOS) {
      this.videoWidth = 270
      this.videoWidth2 = 270
      this.hps = 0.35
      this.isiOS = true
    }
  },
  methods: {
    ini() {
      this.reset()
      var _this = this
      _this.show = true
      this.thisCancas = document.getElementById('canvasCamera')
      this.thisContext = _this.thisCancas.getContext('2d')
      this.thisVideo = document.getElementById('videoCamera')
      // // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      // if (navigator.mediaDevices == undefined) {
      //   navigator.mediaDevices = {}
      // }
      // // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // // 使用getUserMedia，因为它会覆盖现有的属性。
      // // 这里，如果缺少getUserMedia属性，就添加它。
      // if (navigator.mediaDevices.getUserMedia == undefined) {
      //   navigator.mediaDevices.getUserMedia = function(constraints) {
      //     // 首先获取现存的getUserMedia(如果存在)
      //     var getUserMedia =
      //       navigator.webkitGetUserMedia ||
      //       navigator.mozGetUserMedia ||
      //       navigator.getUserMedia
      //     // 有些浏览器不支持，会返回错误信息
      //     // 保持接口一致
      //     if (!getUserMedia) {
      //       return Promise.reject(
      //         new Error('getUserMedia is not implemented in this browser')
      //       )
      //     }
      //     // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
      //     return new Promise(function(resolve, reject) {
      //       getUserMedia.call(navigator, constraints, resolve, reject)
      //     })
      //   }
      // }
      // // 先获取权限，然后再关闭摄像头去调用默认摄像头
      // navigator.mediaDevices
      //   .getUserMedia({ audio: false, video: true })
      //   .then(stream => {
      //     if (stream) {
      //       stream.getTracks().forEach(el => {
      //         el.stop()
      //       })
      //     }
      //   })
      //   .finally(() => {
      //     // this.stopNavigator()
      //   })
      // navigator.mediaDevices.enumerateDevices().then(devices => {
      //   // console.log(devices)
      //   let hasDefult = false //是否有符合的默认摄像头
      //   devices.forEach(e => {
      //     if (e.kind == 'videoinput' && e.deviceId) {
      //       this.camreass.push(e)
      //       if (this.default_cap_id == e.label) {
      //         this.cameraTarget = e
      //         hasDefult = true
      //       }
      //     }
      //   })
      //   if (!hasDefult) {
      //     this.cameraTarget = this.camreass[0]
      //   }
      //   setTimeout(() => {
      //     this.openCameraId()
      //   }, 200)
      // })
      this.openCameraId()
    },
    // 打开指定摄像头
    openCameraId() {
      const w = (window.screen.width * this.getRatio() * 1.16) / 100
      const h = (window.screen.height * this.getRatio() * 1.16) / 100
      let _this = this
      let constraints = {
        audio: false,
        video: {
          facingMode: this.facingMode,
          // deviceId: this.cameraTarget.deviceId,
          // width: this.videoWidth2,
          // height: this.videoHeight2,
          frameRate: { ideal: 10, max: 15 },
          width: { min: 640, max: 3840 }, // 1280
          height: { min: 360, max: 2160 }, // 720
          // width: { ideal: w },
          // height: { ideal: h },
          // width:_this.videoWidth,
          // height: _this.videoHeight,
          transform: 'scaleX(-1)'
        }
      }
      let promise = navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.mediaStream = stream
          // 旧的浏览器可能没有srcObject
          if ('srcObject' in _this.thisVideo) {
            _this.thisVideo.srcObject = stream
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream)
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play()
            _this.openCamera = true
          }
        })
        .catch(err => {})
    },
    //获取屏幕缩放比例
    getRatio() {
      let ratio = 0
      let screen = window.screen
      let ua = navigator.userAgent.toLowerCase()
      if (window.devicePixelRatio != undefined) {
        ratio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (
        window.outerWidth != undefined &&
        window.innerWidth != undefined
      ) {
        ratio = window.outerWidth / window.innerWidth
      }
      if (ratio) {
        ratio = Math.round(ratio * 100)
      }
      return ratio
    },
    //  绘制图片（拍照功能）
    setImage() {
      //-CWidth*((ratio-1)/2),-CHeight*((ratio-1)/2), CWidth*ratio, CHeight*ratio
      var _this = this
      console.log(_this.thisVideo, _this.videoWidth, _this.videoHeight, 1111)
      console.log(
        _this.thisVideo.videoWidth,
        '_this.thisVideo.videoWidth',
        _this.thisVideo.videoHeight
      )
      // _this.videoWidth2 = _this.thisVideo.videoWidth
      // _this.videoHeight2 = _this.thisVideo.videoHeight
      let ww = _this.thisVideo.videoWidth
      let hh = _this.thisVideo.videoHeight
      // 点击，canvas画图
      let thisCancas = document.getElementById('canvasCamera')
      // thisCancas.setAttribute('width', ww)
      // thisCancas.setAttribute('height', hh)
      let thisContext //= thisCancas.getContext('2d')
     if (_this.facingMode == 'environment') {
        ww = ww * _this.wps
        hh = hh * _this.hps
        let left = (_this.thisVideo.videoWidth - ww) / 2 - (0.03*_this.thisVideo.videoWidth)
        let top  = (_this.thisVideo.videoHeight - hh) / 2 + (0.04*_this.thisVideo.videoHeight)
        thisCancas.setAttribute('width', ww)
        thisCancas.setAttribute('height', hh)
        thisContext = thisCancas.getContext('2d')
        // 图片截取中间部分
        thisContext.drawImage(_this.thisVideo, left, top, ww, hh, 0, 0, ww, hh)
      } else {
        thisCancas.setAttribute('width', ww)
        thisCancas.setAttribute('height', hh)
        thisContext = thisCancas.getContext('2d')
        thisContext.drawImage(_this.thisVideo, 0, 0, ww, hh)
      }
      // 获取图片base64链接
      const image = thisCancas.toDataURL('image/jpeg')
      _this.imgSrc = image
      this.haspic = true
      //_this.$emit('refreshDataList', _this.imgSrc)
    },
    reset() {
      this.haspic = false
      this.imgSrc = ''
    },
    // 关闭摄像头
    stopNavigator() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(el => {
          el.stop()
        })
      }
      this.thisVideo.srcObject = null
      this.thisVideo = null
      this.show = false
    },
    //返回图片地址
    save() {
      // 将base64转file
      let filename = 'emp_' + new Date().getTime() + '.png'
      let arr = this.imgSrc.split(',')
      let mime = arr[0].match(/:(.*?);/)[1] /*文件类型*/
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      let file = new File([u8arr], filename, { type: mime })
      this.$emit('beforeRead', file,this.imgSrc)
      this.stopNavigator()
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .carmartbox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    height: 100%;
    .video {
      margin: 0 auto;
      position: relative;
      .rlcj {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
    .topbtn {
      margin: 10px 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 40px;
    }
    .btn {
      margin: 10px 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .van-button {
        width: 100%;
      }
    }
  }
}
</style>
